import script from "./vitals.vue?vue&type=script&setup=true&lang=js"
export * from "./vitals.vue?vue&type=script&setup=true&lang=js"

import "./vitals.vue?vue&type=style&index=0&id=5c1b6b6c&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1b6b6c"]])

export default __exports__